<form>
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
    <div class="card">
        <div class="card-header bg-primary text-left text-white font-weight-bold">
            SPRA Request Data
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <app-contact-view [RefId]="RefId"></app-contact-view>
                        </div>
                        <div class="col-sm-6">
                            <app-customer-ageing [paymentAgingParam]="paymentAgingParam"></app-customer-ageing>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <app-spra-view-data [SPRAId]="SPRAId" [IsForPriceRef]="IsForPriceRef" [ProfitTag]="ProfitTag"></app-spra-view-data>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>